module.exports = __webpack_public_path__ + "img/3-01_mb.22fd0054.png";